import { createContext } from '@egw/utils'
import * as React from 'react'
import { useTransfer } from '../../hooks/transfer'

interface TransferContextInterface {
  children: React.ReactNode
}

const [useTransferContextProvider, ContextProvider] = createContext(useTransfer)

const TransferPageContext = ({ children }: TransferContextInterface): JSX.Element => {
  return <ContextProvider>{children}</ContextProvider>
}

export { TransferPageContext, useTransferContextProvider }
